export enum ListOrderStatus {
    ORDERED = 1,
    NEEDS_APPROVAL = 2,
    REJECTED = 3,
    DELIVERED = 4,
    PARTLY_DELIVERED = 5,
    COMPLETED = 12,
    CANCELED = 13,
    INVOICED = 17,
    INTERNAL_PROCESSING = 21,
    ANSWER_RECEIVED = 23,
    REJECTED_DURING_INTERNAL_PROCESSING = 25,
    CONFIRMED = 111,
    TRANSFERRED = 112,
    TO_BE_RELEASED = 222,
}
